/* bling.js
   @author Paul Irish
   origin - https://gist.github.com/paulirish/12fb951a8b893a454b32
*/
Node.prototype.on = window.on = function(name, fn) {
	this.addEventListener(name, fn);
};

NodeList.prototype.on = NodeList.prototype.addEventListener = function(name, fn) {
	Array.prototype.slice.call(this).forEach(function(elem) {
		elem.addEventListener(name, fn, false);
	});
};

NodeList.prototype.__proto__ = Array.prototype;

module.exports = document.querySelectorAll.bind(document);


// WEBPACK FOOTER //
// ./src/lib/bling.js